import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import {REQUEST} from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { isPlatformBrowser } from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ChartWrapperComponent } from 'src/app/shared/toolbox/charts/chart-wrapper/chart-wrapper.component';

@Component({
  selector: 'app-test-serve',
  templateUrl: './test-serve.component.html',
  styleUrls: ['./test-serve.component.scss'],
})
export class TestServeComponent {

   
}
